
import Number from './number/NumberInput';
import Text from './text/TextInput';
import Select from './select/SelectInput';
import Checkbox from './checkbox/CheckboxInput';
import ComplexWrapper from './wrapper/complex/ComplexInputWrapper';
import Field from './field/InputField';
import Image from './image/ImageInput';
import Switch from './switch/SwitchInput'
import Editor from './text-editor/InputTextEditor'

export default {
  Text,
  Number,
  Select,
  Checkbox,
  ComplexWrapper,
  Field,
  Image,
  Switch,
  Editor
};
